import config from "../config";
import { loadScript } from "../utils";

export function loadLiveChat() {
  const scriptId = "hs-script-loader";
  if (config.configLiveChat?.script && !document.getElementById(scriptId)) {
    loadScript(config.configLiveChat?.script, false, scriptId, "text/javascript");
  }
}
